import {
    FC,
    Dispatch,
    SetStateAction,
    createContext,
    ReactNode,
    useState,
    useContext,
} from "react";
import { NavKey } from "../components/layout/AppLayout";

export type NavKeyValues = `${NavKey}`;

export type AppNavContextType = {
    activeNav: NavKeyValues[];
    setActiveNav: Dispatch<SetStateAction<NavKeyValues[]>>;
    highlightedNav: NavKeyValues[];
    setHighlightedNav: Dispatch<SetStateAction<NavKeyValues[]>>;
};

const AppNavContext = createContext<AppNavContextType | undefined>(undefined);

export const AppNavProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [activeNav, setActiveNav] = useState<NavKeyValues[]>([]);
    const [highlightedNav, setHighlightedNav] = useState<NavKeyValues[]>([]);

    const value = {
        activeNav,
        setActiveNav,
        highlightedNav,
        setHighlightedNav,
    };

    return <AppNavContext.Provider value={value}>{children}</AppNavContext.Provider>;
};

export const useAppNav = () => {
    const context = useContext(AppNavContext);
    if (!context) {
        throw new Error("useAppNav must be used within a AppNavProvider");
    }
    return context;
};
